import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { appRankChangeFilter } from "app/filters/ngFilters";

/**
 * @deprecated Use ChangeCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/views/change-cell/ChangeCell.tsx}
 */

export const Change: FC<ITableCellProps> = ({ value, cellFilter, cellFilterArgs = [" "] }) => {
    const signClass = value < 0 ? "down2 negative" : value > 0 ? "up2 positive" : "";
    const filter = cellFilter ?? appRankChangeFilter;
    return (
        <div className="text-right changePercentage">
            <span className={`sw-icon-arrow-${signClass}`}> {filter()(value, ...cellFilterArgs)}</span>
        </div>
    );
};
Change.displayName = "Change";
